<template>
  <el-select
    v-model="value"
    filterable
    placeholder="请选择品牌"
    :style="styleRef"
    @change="handleChange"
  >
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
      <span style="float: left">{{ item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{
        item.caterotyDescr
      }}</span>
    </el-option>
  </el-select>
</template>
<script>
import { getMyList } from "@/api/brand";

export default {
  props: {
    value: {
      type: Number
    },
    styleRef: {
      type: Object
    },
    type: {
      type: String
    }
  },
  created() {
    this.getMyList();
  },
  components: {},
  filters: {},
  data() {
    return {
      optionValue: this.value,
      options: []
    };
  },
  methods: {
    /**
     * 查询级联标签
     */
    getMyList() {
      const params = {};
      getMyList(params).then(resp => {
        this.options = resp.data || [];
      });
    },
    /**
     * 节点选中的值
     * @param events
     */
    handleChange(events) {
      this.$emit("valueFunc", this.type, events);
    }
  }
};
</script>

<style scoped lang="scss"></style>
